import React, { forwardRef } from 'react';
import Lottie from "lottie-react";
import animationData from "./loading_animation.json";
import styles from './LoadingScreen.module.scss';

const LoadingScreen = forwardRef((props, ref) => {
  return (
    <div className={styles.container} ref={ref}>
      <Lottie animationData={animationData} loop={true} />
      <p className={styles.text}>Аналізуємо вашу діяльність і підбираємо класи ТМ</p>
    </div>
  );
});

export default LoadingScreen;